import axiosClient from './axiosClient';

// Catalogo del rol distribuidor: mismos productos activos, con sus precios propios.
// Requiere sesion iniciada con rol "distribuidor" (ver routes/api.php en el backend).
const distributorApi = {
  getDistributorProducts: (params) => axiosClient.get('/distributor/products', { params }),
};

export default distributorApi;
